import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useSwiper } from 'hooks'
import {
  CarouselContainer,
  CarouselNextButton,
  CarouselPrevButton
} from 'ui/acro'

import CarouselSlides from './HeroSlides'

const Sticky = styled.div`
  position: sticky;
  top: 144px;
`

const paginationClass = '.hero-pagination'

const Carousel = ({ previewMedia, planId }) => {
  const { getSwiperProps, goNext, goPrev, isBeginning, isEnd } =
    useSwiper(paginationClass)

  return (
    <Sticky>
      <CarouselContainer paginationClass={paginationClass}>
        <Swiper
          {...getSwiperProps({
            autoHeight: true,
            roundLengths: true,
            slidesPerGroup: 1,
            slidesPerView: 'auto',
            spaceBetween: 22,
            watchOverflow: true,
            watchSlidesVisibility: true,
            pagination: {
              el: paginationClass,
              clickable: true
            }
          })}
        >
          {previewMedia && (
            <SwiperSlide
              tag={CarouselSlides}
              planId={planId}
              previewMedia={previewMedia}
            />
          )}
        </Swiper>
        <CarouselPrevButton
          handleClick={goPrev}
          disabled={isBeginning}
          display={['none', null, 'inherit']}
          top='50%'
          left='-4%'
          id='hero-carousel-prev'
          aria-label='Previous'
        />
        <CarouselNextButton
          handleClick={goNext}
          disabled={isEnd}
          display={['none', null, 'inherit']}
          top='50%'
          right='-4%'
          id='hero-carousel-next'
          aria-label='Next'
        />
      </CarouselContainer>
    </Sticky>
  )
}

Carousel.propTypes = {
  previewMedia: PropTypes.array,
  planId: PropTypes.number
}

export default Carousel
